<template>
  <v-navigation-drawer :width="collapsed ? '60' : '280'" app permanent>
    <sidebar-menu
      v-model:collapsed="collapsed"
      :menu="arraymenu"
      :theme="ChangeTheme ? '' : 'white-theme'"
      @item-click="onItemClick"
    >
      <div
        v-if="isOnMobile && !collapsed"
        class="sidebar-overlay"
        @click="collapsed = true"
      />
      <div
        id="demo"
        :class="[{ collapsed: collapsed }, { onmobile: isOnMobile }]"
      >
        <div class="demo"></div>
      </div>
    </sidebar-menu>
  </v-navigation-drawer>
</template>
<script>
import store from "@/store";
import { SidebarMenu } from "vue-sidebar-menu";
import axios from "axios";
export default {
  components: {
    SidebarMenu,
  },
  props: {
    ChangeTheme: {
      type: Boolean,
      default: false,
      Description: "Cambio de Tema",
    },
  },
  data: () => ({
    arraymenu: [],
    selectedTheme: "white-theme",
    isOnMobile: false,
    collapsed: false,
  }),
  methods: {
    onResize() {
      if (window.innerWidth <= 767) {
        this.isOnMobile = true;
        this.collapsed = true;
      } else {
        this.isOnMobile = false;
        this.collapsed = false;
      }
    },
    onItemClick(event, item) {
      if (item.href != null && item.href != "" && item.href != undefined) {
        this.$store.commit("paginainfo", item);
      }
    },
    // Consulta si el usuario exista en el sistema
    MenuGet() {
      debugger;
      var userperfil = this.$store.getters.userperfil.infoperfil;
      console.log(this.$store.getters.userperfil);
      this.axios
        .get("/Menu/perfiles?perfil=" + userperfil.Perfil_ID)
        .then((response) => {
          console.log(response.data);
          this.arraymenu = response.data;
          this.$store.commit("registromenu", this.arraymenu);
        })
        .catch((e) => console.log(e));
    },
  },
  created() {
    this.MenuGet();
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
};
</script>
<style lang="scss">
@import "./src/scss/vue-sidebar-menu.scss";
#demo {
  padding-left: 290px;
  transition: 0.3s ease;
}
#demo.collapsed {
  padding-left: 65px;
}
#demo.onmobile {
  padding-left: 65px;
}

.sidebar-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  opacity: 0.5;
  z-index: 900;
}

.demo {
  padding: 50px;
}
</style>
